import React from 'react'
import Container from '@/components/Container/index'
import { Form, Button, DatePicker, Divider, Table, Pagination, Tooltip } from 'antd';
import { connect } from 'dva';
import moment from 'moment';
import style from './index.less'

const { RangePicker } = DatePicker;

const columns = [
  {
    title: '姓名',
    width: 232,
    dataIndex: 'userName',
    key: 'userId',
    fixed: 'left',
  },
  {
    title: '部门',
    dataIndex: 'deptName',
    key: 'deltId',
    render: deptName => {
      if (deptName && deptName.length > 12) {
        return (
          <Tooltip placement="top" title={deptName}>
            <div className="title">{`${deptName.substring(0, 12)}...`}</div>
          </Tooltip>
        );
      }
      return `${deptName || "暂无"}`;
    }
  },
  {
    title: '祝福类型',
    dataIndex: 'wishType',
    key: 'wishType',
    width: 268,
    render: wishType => (
      <span>{(wishType === "birthday" && "生日") || (wishType === "employee" && "入职周年")}
      </span>
    )
  },

  {
    title: '推送时间',
    dataIndex: 'pushDate',
    key: 'pushDate',
    width: 187,
    render: pushDate => (
      <span>{pushDate.substring(16, 0)}
      </span>
    )
  },
];

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};


@connect(({ getPushRuless }) => ({
  ...getPushRuless
}))
class PushRecord extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      pagesize: 10,
      pushtime: []
    }
  }

  componentDidMount () {
    this.getPushRecord()
  }



  // 请求推送记录
  getPushRecord () {
    const { page, pagesize, pushtime } = this.state
    const { dispatch } = this.props
    dispatch({
      type: 'getPushRuless/getpushReacord',
      payload: {
        page: page || '',
        pageSize: pagesize || '',
        endDate: pushtime.length > 1 ? pushtime[1] : '',
        startDate: pushtime.length > 1 ? pushtime[0] : ''
      }
    })
  }

  onFill = () => {
    const { form } = this.props
    form.setFieldsValue({
      'range_picker': [],
    });
    this.setState({
      page: 1,
      pagesize: 10,
      pushtime: []
    }, () => {
      console.log(this.state);
      this.getPushRecord()
    })
  };


  // 选择日期
  handleSubmit = e => {
    e.preventDefault();
    const { form } = this.props
    form.validateFields((err, fieldsValue) => {
      if (err) {
        return;
      }
      const rangeValue = fieldsValue.range_picker;
      if (rangeValue) {
        const values = {
          ...fieldsValue,
          'range_picker': [rangeValue[0].format('YYYY-MM-DD'), rangeValue[1].format('YYYY-MM-DD')],
        };
        this.setState({
          page: 1,
          pagesize: 10,
          pushtime: values.range_picker
        }, () => {
          console.log(this.state);
          this.getPushRecord()
        })
      } else {
        this.setState({
          page: 1,
          pagesize: 10,
        }, () => {
          console.log(this.state);
          this.getPushRecord()
        })
      }

    });
  };

  // 点击改变页数
  onChange = (page, pageSize) => {
    this.setState({
      page: parseInt(page, 10),
      pagesize: parseInt(pageSize, 10)
    }, () => {
      console.log(this.state);
      this.getPushRecord()
    })

  }

  // 选择每页条数
  showSize = (current, size) => {
    this.setState({
      page: 1,
      pagesize: parseInt(size, 10)
    }, () => {
      console.log(this.state);
      this.getPushRecord()
    })
  }

  // 时间限制
  disabledDate = (current) => {
    return current > moment() || current < moment("1950-01-01")
  }


  render () {
    const { form, record } = this.props
    const { content, page, pageSize, totalElements } = record || {}
    const { getFieldDecorator } = form;
    function showTotal (total) {
      return `共${total}条记录`;
    }
    return (
      <div className={style.pushrecord}>
        <Container>
          <div className={style.pushrecord_content}>
            <Form {...formItemLayout} onSubmit={this.handleSubmit}>
              <Form.Item label="筛选日期">
                {getFieldDecorator('range_picker')(
                  <RangePicker placeholder={['请选择', '请选择']} disabledDate={this.disabledDate} />
                )}
              </Form.Item>
              <Form.Item
                wrapperCol={{
                  xs: { span: 24, offset: 0 },
                  sm: { span: 16, offset: 8 },
                }}
              >
                <Button type="primary" htmlType="submit">
                  查询
                </Button>
              </Form.Item>
              <Form.Item
                wrapperCol={{
                  xs: { span: 24, offset: 0 },
                  sm: { span: 16, offset: 8 },
                }}
              >
                <Button htmlType="button" onClick={this.onFill}>
                  重置
                </Button>
              </Form.Item>
            </Form>
            <Divider />
            <div className={style.pushrecord_table}> <Table
              columns={columns}
              pagination={false}
              dataSource={(content || [])}
            />
              <Pagination current={page} onChange={this.onChange} total={(totalElements || '')} onShowSizeChange={this.showSize} defaultCurrent={page} defaultPageSize={pageSize} showSizeChanger showQuickJumper showTotal={showTotal} />
            </div>
          </div>
        </Container>
      </div>
    )
  }
}
const WrappedTimePushRecord = Form.create({ name: 'time_related_controls' })(PushRecord);
export default WrappedTimePushRecord